import script from "./ShareholderFunds.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareholderFunds.vue?vue&type=script&setup=true&lang=js"

import "./ShareholderFunds.vue?vue&type=style&index=0&id=3cb831fc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb831fc"]])

export default __exports__